import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { authenticated, loading } = useAdminAuth();

  useEffect(() => {
    if (!loading) {
      if (authenticated) {
        navigate('/admin/dashboard');
      } else {
        // Redirect to unified auth page
        navigate('/auth');
      }
    }
  }, [authenticated, loading, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
    </div>
  );
};

export default AdminLogin;
